import styled from 'styled-components';
import { Select } from '@material-ui/core';

export const DiffsSelect = styled(Select)`
  min-width: 220px;
`;

export const DiffsComboBoxStyled = styled.div`
  padding: 20px;
  display: flex;
`;

export const DiffsDatePickerStyled = styled.div`
  padding: 20px;
  display: flex;
  width: 220px;
`;

export const DiffsLayout = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: row;
`;
